import * as healthInsuranceCardTypes from '~/store/payment/paymentType';
const initialState = {
  loading: false,
  data: [],
  paymentID: '',
  selectedHealthInsuranceCard: {},
  showModal: false,
  showResendSMSModal: false,
  showResendSMSOK: false,
  resendSMSMessage: '',
  errors: {},
};

export default function locale(state = initialState, action = {}) {
  switch (action.type) {
    case healthInsuranceCardTypes.REQUEST_HEALTH_INSURANCE_CARD:
      return {
        ...state,
        paymentID: action.paymentID,
        loading: true,
      };

    case healthInsuranceCardTypes.REQUEST_HEALTH_INSURANCE_CARD_SUCCESS:
      return {
        ...state,
        data: action.data,
        loading: false,
      };
    case healthInsuranceCardTypes.REQUEST_HEALTH_INSURANCE_CARD_FAIL:
      return {
        ...state,
        errors: action.errors,
        loading: false,
      };
    case healthInsuranceCardTypes.GET_MEDICAL_BILL_BY_HOSPITALID_REQUEST:
      return {
        ...state,
        data: action.data,
        loading: true,
      };

    case healthInsuranceCardTypes.GET_MEDICAL_BILL_BY_HOSPITALID_SUCCESS:
      return {
        ...state,
        data: action.data,
        loading: false,
      };
    case healthInsuranceCardTypes.GET_MEDICAL_BILL_BY_HOSPITALID_FAILURE:
      return {
        ...state,
        errors: action.errors,
        loading: false,
      };
    case healthInsuranceCardTypes.SELECTED_HEALTH_INSURANCE_TO_SHOWM_MODAL:
      return {
        ...state,
        selectedHealthInsuranceCard: { ...action.info },
        showModal: true,
      };
    case healthInsuranceCardTypes.SELECTED_HEALTH_INSURANCE_TO_SHOWM_RESEND_SMS_MODAL:
      return {
        ...state,
        selectedHealthInsuranceCard: { ...action.info },
        showResendSMSModal: true,
      };
    case healthInsuranceCardTypes.TOGGLE_MODAL_HEALTH_INSURANCE_CARD:
      return {
        ...state,
        showModal: false,
      };
    case healthInsuranceCardTypes.TOGGLE_RESEND_SMS_MODAL_HEALTH_INSURANCE_CARD:
      return {
        ...state,
        showResendSMSModal: false,
      };
    case healthInsuranceCardTypes.SHOW_RESEND_SMS_OK_MODAL_HEALTH_INSURANCE_CARD:
      return {
        ...state,
        showResendSMSOK: true,
        resendSMSMessage: action.message,
      };
    case healthInsuranceCardTypes.HIDE_RESEND_SMS_OK_MODAL_HEALTH_INSURANCE_CARD:
      return {
        ...state,
        showResendSMSOK: false,
      };
    default:
      return state;
  }
}
